import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import {
  generateBreadcrumbStructuredData,
  generatePlansStructuredData,
} from "../../components/SEO/StructuredData";
import PlanTierCards from "../../components/plans/PlanTierCards";
import PlanTerms from "../../components/plans/PlanTerms";
import {
  PLANS_DESCRIPTION,
  PLANS_H1,
  PLANS_LEDE,
  PLANS_TEASER,
  PLANS_TITLE,
} from "../../utility/aiAssistCopy";

const Plans = () => (
  <ProductPage
    title={PLANS_TITLE}
    description={PLANS_DESCRIPTION}
    keywords={[
      "bowling tournament software pricing",
      "AI Assist",
      "bowling tournament signup sheet import",
    ]}
    canonicalUrl="/pricing"
    heading={PLANS_H1}
    lede={PLANS_LEDE}
    analyticsLocation="pricing"
    showNextStep={false}
    structuredData={generatePlansStructuredData({
      name: PLANS_TITLE,
      description: PLANS_DESCRIPTION,
      dateModified: "2026-11-04",
    })}
    additionalStructuredData={[
      generateBreadcrumbStructuredData([
        { label: "Home", path: "/" },
        { label: "Plans", path: "/pricing" },
      ]),
    ]}
  >
    <p className="text-brand-muted max-w-2xl">{PLANS_TEASER}</p>
    <PlanTierCards planCta location="pricing" />
    <div className="mt-10 w-full">
      <PlanTerms variant="accordion" />
    </div>
  </ProductPage>
);

export default Plans;
